import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoaderService } from "../../../services/loader.service";
import { UserService } from "../../../services/user.service";
import { PageTitleService } from '../../../services/page-title.service';

@Component({
  selector: 'psc-forgot-password-request',
  templateUrl: './forgot-password-request.component.html'
})
export class ForgotPasswordRequestComponent implements OnInit {
  formGroup: FormGroup;
  emailSent: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private loaderService: LoaderService,
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.forgot-pass-request)
     */
    this.pageTitleService.setTitle('title.forgot-pass-request');
  }


  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if(!this.formGroup.valid) {
      return;
    }
    this.loaderService.showLoader();
    this.userService.forgotPassword(this.formGroup.controls['email'].value ).subscribe({
      next: () => {
        this.emailSent = true;
      },
    }).add(() => {
      this.loaderService.hideLoader();
    });
  }
}
